import { ApiClientSocialMediaAutoSubmission } from '@helpers/apiClients';
import { SocialMediaCategory, SocialMediaPlatform } from '@services/types/api';
import * as yup from 'yup';
import { getAutoSubmissionAPIEndpoint } from '../utils/auto-submission';
import { MutationConfig } from '@helpers';
import { useMutation } from 'react-query';

export const autoSubmissionTikTokSchema = yup.object({
  email: yup.string().nullable().required('Email is required').email('Must be a valid email'),
  full_name: yup.string().nullable().required('Full Name is required'),
  copyright_owner: yup.string().nullable().required('Copyright Owner is required'),
  customer_tiktok_account: yup.string().nullable(),
  original_work: yup.string().nullable().required('Original Work is required'),
  report_content: yup.string().nullable().required('Report Content is required'),
  phone_number: yup.string().nullable(),
  address: yup.string().nullable(),
  authorization_file: yup.mixed().nullable().required('Authorization File is required'),
});

export const autoSubmissionImpersonationTikTokSchema = yup.object({
  email: yup.string().nullable().required('Email is required').email('Must be a valid email'),
  full_name: yup.string().nullable().required('Full Name is required'),
  copyright_owner: yup.string().nullable().required('Copyright Owner is required'),
  customer_tiktok_account: yup.string().nullable().required('Customer TikTok Account is required'),
  original_work: yup.string().nullable().required('Original Work is required'),
  report_content: yup.string().nullable().required('Report Content is required'),
  phone_number: yup.string().nullable(),
  address: yup.string().nullable(),
  authorization_file: yup.mixed().nullable().required('Authorization File is required'),
});

export const autoSubmissionSchema = {
  [SocialMediaCategory.CopyrightViolation]: {
    [SocialMediaPlatform.TIKTOK]: autoSubmissionTikTokSchema,
  },
  [SocialMediaCategory.Impersonation]: {
    [SocialMediaPlatform.TIKTOK]: autoSubmissionTikTokSchema,
  },
};

export const submitAutoSubmission = ({
  data,
  category,
  platform,
}: {
  category: SocialMediaCategory;
  platform: SocialMediaPlatform;
  data: any;
}) => {
  return ApiClientSocialMediaAutoSubmission.post(
    getAutoSubmissionAPIEndpoint(category, platform),
    data,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
        'x-api-key': process.env.REACT_APP_AUTO_SUBMISSION_API_KEY || '',
      },
    },
  );
};

type UseSubmitAutoSubmissionOptions = {
  mutationConfig?: MutationConfig<typeof submitAutoSubmission>;
};

export const useSubmitAutoSubmission = ({
  mutationConfig,
}: UseSubmitAutoSubmissionOptions = {}) => {
  const { onSuccess, ...restConfig } = mutationConfig || {};

  return useMutation({
    onSuccess: (...args) => {
      onSuccess?.(...args);
    },
    ...restConfig,
    mutationFn: submitAutoSubmission,
  });
};
